import { takeEvery, takeLatest } from "redux-saga/effects";

import * as types from "../../constants/actionTypes";
import * as myToposSagas from "./MyTopologiesSagas";
import * as newTopologySagas from "./NewTopologySagas";
import * as queueRequestsSagas from "./QueueRequestsSagas";
import * as taskListSagas from "./TaskListSagas";

export function* watchGetMyTopologies() {
  yield takeLatest(types.FETCH_MYTOPOS_REQUESTED, myToposSagas.getMyTopologiesSaga);
}

export function* watchDelete() {
  yield takeEvery(types.DELETE_REQUESTED, myToposSagas.deleteTopologiesSaga);
}

export function* watchGetTasks() {
  yield takeLatest(types.FETCH_TASKS_REQUESTED, myToposSagas.getTasksSaga);
}

export function* watchResetTask() {
  yield takeLatest(types.RESET_TASK_REQUESTED, taskListSagas.resetTaskSaga);
}

export function* watchSkipTask() {
  yield takeLatest(types.SKIP_TASK_REQUESTED, taskListSagas.skipTaskSaga);
}

export function* watchPauseTask() {
  yield takeLatest(types.PAUSE_TASK_REQUESTED, taskListSagas.pauseTaskSaga);
}

export function* watchGetTaskLogs() {
  yield takeLatest(types.FETCH_TASK_LOGS_REQUESTED, taskListSagas.getTaskLogsSaga);
}

export function* watchGetPropertyBag() {
  yield takeLatest(types.FETCH_PROPERTY_BAG_REQUESTED, taskListSagas.getPropertyBagSaga);
}

export function* watchUploadPropertyBag() {
  yield takeLatest(types.UPLOAD_PROPERTY_BAG_REQUESTED, taskListSagas.uploadPropertyBagSaga);
}

export function* watchGetTopologyTypesSaga() {
  yield takeLatest(types.FETCH_TOPOLOGY_TYPES_REQUESTED, newTopologySagas.getTopologyTypesSaga);
}

export function* watchGetCloudTypesDefaultClassicSaga() {
  yield takeLatest(types.FETCH_CLOUD_TYPES_DEFAULT_CLASSIC_REQUESTED, newTopologySagas.getCloudTypesDefaultClassicSaga);
}

export function* watchCheckoutTopologySaga() {
  yield takeLatest(types.CHECKOUT_REQUESTED, newTopologySagas.checkoutTopologySaga);
}

export function* watchDeployTopologyTypeWithQueueSaga() {
  yield takeLatest(types.DEPLOY_TOPOLOGY_TYPE_WITH_QUEUE_REQUESTED, newTopologySagas.deployTopologyTypeWithQueueSaga);
}

export function* watchUploadTemplateSaga() {
  yield takeLatest(types.UPLOAD_TEMPLATE_REQUESTED, newTopologySagas.uploadTemplateSaga);
}

export function* watchUploadTemplateForLookupFileSaga() {
  yield takeLatest(types.UPLOAD_TEMPLATE_FOR_LOOKUP_FILE_REQUESTED, newTopologySagas.uploadTemplateForLookupFileSaga);
}

export function* watchUploadLookupFileSaga() {
  yield takeLatest(types.UPLOAD_LOOKUPFILE_REQUESTED, newTopologySagas.uploadLookupFileSaga);
}

export function* watchDeployPrivateTemplateSaga() {
  yield takeLatest(types.DEPLOY_PRIVATE_TEMPLATE_REQUESTED, newTopologySagas.deployPrivateTemplateSaga);
}

export function* watchDeployLookupTopologyTypeSaga() {
  yield takeLatest(types.DEPLOY_LOOKUP_TOPOLOGY_TYPE_REQUESTED, newTopologySagas.deployLookupTopologyTypeSaga);
}

export function* watchGetDuplicateThresholdTopologiesSaga() {
  yield takeLatest(
    types.FETCH_DUPLICATE_THRESHOLD_TOPOLOGY_NAMES_REQUESTED,
    newTopologySagas.getDuplicateThresholdTopologiesSage,
  );
}

export function* watchGetUserRegionSaga() {
  yield takeLatest(types.GET_USER_REGION_REQUESTED, newTopologySagas.getUserRegionSaga);
}

export function* watchRenameTopologySaga() {
  yield takeLatest(types.RENAME_TOPOLOGY_REQUESTED, myToposSagas.renameTopologySaga);
}

export function* watchTransferOwnershipSaga() {
  yield takeLatest(types.TRANSFER_OWNERSHIP_REQUESTED, myToposSagas.transferOwnershipSaga);
}

export function* watchGetDebuggerPortSaga() {
  yield takeLatest(types.FETCH_DEBUGGER_PORT_REQUESTED, myToposSagas.getDebuggerPortSaga);
}

export function* watchGetMyQueueRequestsSaga() {
  yield takeLatest(types.FETCH_MYQUEUEREQUESTS_REQUESTED, queueRequestsSagas.getMyQueueRequestsSaga);
}

export function* watchCancelQueueRequestSaga() {
  yield takeLatest(types.CANCEL_QUEUE_REQUEST_REQUESTED, queueRequestsSagas.cancelQueueRequestSaga);
}
